var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    d: "M52.697 87.232c-.693-.356-1.265-1.541-1.265-1.541l-6.113-16.909c.155.014.424.024.544-.051 2.968-1.875 29.864-18.848 31.416-19.418.245-.073.425.01.377.18-.621 2.177-23.981 22.928-23.981 22.928s-.094.106-.15.238l-.026-.016-1.218 12.935s-.164 1.273.416 1.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.6,
    d: "M53.5 72.639l-1.218 12.934s-.51 3.962 3.455 0c3.966-3.962 7.76-7.019 7.76-7.019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.204 68.765l-13.048-4.249S30.6 63.884 31.1 62.45c.104-.296.312-.547.935-.981 2.891-2.014 53.516-20.198 53.516-20.198s1.43-.481 2.274-.161c.386.146.632.311.84.915.075.22.118.686.114 1.151-.005.335-.046.645-.076 1.132-.309 4.972-9.534 42.076-9.534 42.076s-.552 2.171-2.53 2.246c-.721.026-1.597-.12-2.643-1.02-3.881-3.336-17.297-12.346-20.26-14.328-.168-.111-.216-.256-.244-.398-.042-.209.185-.468.185-.468s23.36-20.75 23.982-22.928c.048-.169-.133-.252-.378-.18-1.552.57-28.447 17.543-31.415 19.418-.174.11-.66.039-.66.039"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0287988318357fb1f99e255b2eb4347f.svg";
export { ForwardRef as ReactComponent };